"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "de": {
        "translation": {
            "page_header": {
                "example": "Beispiel",
                "icons": {
                    "academy": "Akademie",
                    "asset_inventory": "Anlagenbestand",
                    "assets_and_attributes": "Anlagen und Attribute",
                    "assurance_plans": "Sicherungspläne",
                    "bulk_importer": "Massenimportprogramm",
                    "compliance_maps": "Compliance-Maps",
                    "community": "Community",
                    "frameworks": "Frameworks",
                    "issue_tracker": "Problemverfolgung",
                    "launchpad": "Launchpad",
                    "mission_control": "Kontrollzentrum",
                    "projects": "Projekte",
                    "reports": "Berichte",
                    "results": "Ergebnisse",
                    "robots": "Robots",
                    "scheduler": "Ablaufplaner",
                    "storyboard": "Storyboards",
                    "strategy": "Strategie",
                    "task_tracker": "Aufgabenverfolgung",
                    "time_sheets": "Stundennachweise",
                    "toolkits": "Toolkits"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=de.js.map